'use client';

import React from 'react';
import Navbar from '@components/Navbar';
import Footer from '@components/footer/Footer';
import styles from './esa.module.css';

export default function ESAPage() {
  return (
    <>
      <Navbar />

      <div className={styles.mainContainer}>
        {/* ===== HERO ===== */}
        <header className={styles.siteHeader}>
          <div className={styles.container}>
            <h1 className={styles.heroTitle}>Education Savings Account (ESA) Programs</h1>
            <p className={styles.heroText}>
              PenguinLearn is approved to accept ESA funds in select states. Our team helps families
              use ESA funding smoothly to enroll in live online classes.
            </p>
          </div>
        </header>

        {/* ===== APPROVED STATES SECTION ===== */}
        <section className={`${styles.container} ${styles.section}`}>
          <h2 className={styles.sectionHeading}>Where PenguinLearn Is Approved</h2>
          <p className={styles.sectionText}>
            Families in the states below can use ESA funds to enroll in eligible PenguinLearn classes.
          </p>

          <div className={styles.esaProgramsGrid}>

            {/* Arizona */}
            <article className={styles.esaProgramCard}>
              <p className={styles.programState}>Arizona</p>
              <h3 className={styles.programTitle}>Empowerment Scholarship Accounts ESA</h3>
              <p className={styles.programText}>
                Arizona families can use ESA funds at PenguinLearn through
                <strong> ClassWallet</strong>. You can find the class you would like on
                <strong> PenguinLearn</strong>, and on the checkout page choose to pay with
                <strong> ESA</strong>. You can also log in to <strong>ClassWallet</strong> and search
                for <strong>“PenguinLearn”</strong>.
              </p>
              <div className={styles.programActions}>
                <a
                  href="https://main-auth.classwallet.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                >
                  Log in to ClassWallet
                </a>
              </div>
            </article>

            {/* Alabama */}
            <article className={styles.esaProgramCard}>
              <p className={styles.programState}>Alabama</p>
              <h3 className={styles.programTitle}>CHOOSE Act ESA</h3>
              <p className={styles.programText}>
                Alabama families can use ESA funds at PenguinLearn through
                <strong> ClassWallet</strong>. You can find the class you would like on
                <strong> PenguinLearn</strong>, and on the checkout page choose to pay with
                <strong> ESA</strong>. You can also log in to <strong>ClassWallet</strong> and search
                for <strong>“PenguinLearn”</strong>.
              </p>
              <div className={styles.programActions}>
                <a
                  href="https://main-auth.classwallet.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                >
                  Log in to ClassWallet
                </a>
              </div>
            </article>

            {/* Arkansas */}
            <article className={styles.esaProgramCard}>
              <p className={styles.programState}>Arkansas</p>
              <h3 className={styles.programTitle}>Childrens Educational Freedom Account</h3>
              <p className={styles.programText}>
                Arkansas families can use ESA funds at PenguinLearn through
                <strong> ClassWallet</strong>. You can find the class you would like on
                <strong> PenguinLearn</strong>, and on the checkout page choose to pay with
                <strong> ESA</strong>. You can also log in to <strong>ClassWallet</strong> and search
                for <strong>“PenguinLearn”</strong>.
              </p>
              <div className={styles.programActions}>
                <a
                  href="https://main-auth.classwallet.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                >
                  Log in to ClassWallet
                </a>
              </div>
            </article>

                        {/* Utah */}
                        <article className={styles.esaProgramCard}>
              <p className={styles.programState}>Utah</p>
              <h3 className={styles.programTitle}>Utah Fits All Scholarship</h3>
              <p className={styles.programText}>
                Utah families can use Utah Fits All ESA funds to enroll in PenguinLearn’s approved online
                classes. Log in to your <strong>Odyssey</strong> account, search for <strong>“PenguinLearn”</strong>,
                and purchase the course using your ESA funds. After your purchase, our team will enroll your
                student in any available section of the course you selected.
              </p>
              <div className={styles.programActions}>
                <a
                  href="https://ufa-schools.withodyssey.com/login/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                >
                  Log in to Odyssey
                </a>
                <a
                  href="https://www.utaheducationfitsall.org/faqs/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonSecondary}`}
                >
                  Learn about Utah Fits All
                </a>
              </div>
            </article>

            {/* Louisiana */}
            <article className={styles.esaProgramCard}>
              <p className={styles.programState}>Louisiana</p>
              <h3 className={styles.programTitle}>LA GATOR Scholarship</h3>
              <p className={styles.programText}>
                Louisiana ESA families can apply approved funds toward eligible PenguinLearn classes.
                Log in to your <strong>Odyssey</strong> account, search for <strong>“PenguinLearn”</strong>,
                and purchase the course using your ESA funds. After your purchase, our team will enroll your
                student in any available section of the course you selected.
              </p>
              <div className={styles.programActions}>
                <a
                  href="https://lagator-schools.withodyssey.com/login/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonPrimary}`}
                >
                  Log in to Odyssey
                </a>
                <a
                  href="https://doe.louisiana.gov/topic-pages/louisiana-school-choice/la-gator/la-gator-families"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.button} ${styles.buttonSecondary}`}
                >
                  Learn about Louisiana ESA
                </a>
              </div>
            </article>
          </div>
        </section>

        {/* ===== HOW IT WORKS ===== */}
        <section className={`${styles.container} ${styles.section}`}>
          <h2 className={styles.sectionHeading}>How It Works</h2>
          <p className={styles.sectionText}>
            ESA programs vary by state, but families can typically use one of these two paths:
          </p>

          <div className={styles.stepsGrid}>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>1</div>
              <h3 className={styles.stepTitle}>Find your class</h3>
              <p className={styles.stepBody}>
                Browse PenguinLearn and choose the class that fits your student’s needs.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>2</div>
              <h3 className={styles.stepTitle}>Use Odyssey or ClassWallet</h3>
              <p className={styles.stepBody}>
                Utah and Louisiana families can log in to <strong>Odyssey</strong>. Arizona, Alabama,
                and Arkansas families can log in to <strong>ClassWallet</strong>.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>3</div>
              <h3 className={styles.stepTitle}>Search “PenguinLearn”</h3>
              <p className={styles.stepBody}>
                Search for <strong>PenguinLearn</strong> in the ESA marketplace, or go through checkout
                on PenguinLearn and choose to pay with <strong>ESA</strong> where available.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>4</div>
              <h3 className={styles.stepTitle}>Complete your purchase</h3>
              <p className={styles.stepBody}>
                Use your approved ESA funds to complete the purchase for the class you selected.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>5</div>
              <h3 className={styles.stepTitle}>Start learning!</h3>
              <p className={styles.stepBody}>
                Once confirmed, your student can join their live PenguinLearn class.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}